<script lang="ts" setup>
import { AdvTypeEnum, BannerTypeEnum, PositionTypeEnum } from "@/types/enumTypes";
import { openUrl } from "@/utils/openUrl";
import trackEvent from '@/utils/trackEvent'
// import { getProjectImageUrl } from "@/utils";
const globalStroe = useGlobalStore();
const { appData, curAdvDomain, appConfig, isNanTong } = storeToRefs(globalStroe);
const { path } = useRoute();
const time = 5000;
const show = ref(false);

const showRun = ref(true);
// const close = () => {
//   show.value = false;
// };

const change = (e: any) => {
  if (e.seconds === 0) {
    show.value = false;
  }
};
//获取路线切换广告图片域名
const domainUrl: any = computed(() => {
  return curAdvDomain?.value?.url || "";
});
// console.log(domainUrl);
// 获取 当前app对象 ==> 启动页 ==> 头部广告对象 ==> 广告列表
const topBannerAds = computed(() => appData.value?.advList?.[AdvTypeEnum.START_ADV]?.[PositionTypeEnum.TOP]?.[BannerTypeEnum.BANNER] || []);

// 启动页广告地址
const imgUrl = computed(() => topBannerAds.value[0]?.imgUrl || "");
console.log("启动页广告地址", imgUrl.value);
// 判断是否有启动页广告
if (imgUrl.value.length && path == "/") {
  show.value = true;
}

const imageClick = (item: any) => {
  trackAction(item); // 启动 loading 广告 打点
  // 点击广告图片时触发
  // console.log('点击了广告图片', item)
  if (item.jumpUrl) {
    let urlStr = decodeURIComponent(item.jumpUrl).replace(/amp;/g, "");
    // console.log(urlStr)
    openUrl(urlStr);
  }
};

const trackAction = item => {
  trackEvent({ type: 'clklog', category: 'advertise', id: item.id, name: item.name, advertiseType: item.category })

};

const sys = /Android|Adr/.test(navigator.userAgent) ? "android" : "ios";
document.body.setAttribute("sys", sys);

const msg = ref("正在加载...");
const num = ref(0);

const startLoading = () => {
  const jumpInterval = setInterval(() => {
    if (URL) {
      if (num.value >= 100) {
        clearInterval(jumpInterval);
      } else {
        num.value += 2;
      }
    }
  }, 30); //秒跳转,  秒*10
};
// 监听appData变化，如果接口返回数据显示启动页
const handleAppDataChange = () => {
  showRun.value = false;

  if (!appData.value) {
    show.value = false;
    return;
  }

  show.value = imgUrl.value.length > 0 && path === "/";
};

watch(appData, handleAppDataChange);

onMounted(() => {
  startLoading();
});
</script>

<template>
  <div v-show="show" class="app-loadding"
    :class="appConfig.getTemplateClass">
    <div class="img-con" :class="{ 'start-screen': isNanTong }" @click="imageClick(topBannerAds[0])">
      <ImageWrap :adInfo="topBannerAds[0]" v-if="domainUrl" :fit="'cover'" :src="domainUrl + imgUrl" height="100%"
        :notLoading="true" width="100%" />
    </div>
    <div class="load-close pt-sa-top">
      <van-count-down v-if="isNanTong" :time="time" format="跳过 S" @change="change" />
      <van-count-down v-else :time="time" format="ss秒" @change="change" />
    </div>
  </div>
  <div v-if="showRun" class="main" :class="isNanTong ? 'bg-[#ECECF5]' : 'bg-black'">
    <div id="loading">
      <b class="text-color">{{ num }}%</b>
      <p>{{ msg }}</p>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.main {
  background: #000;
  text-align: center;
  margin: 0;
  color: #fff;
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  overflow: hidden;
}

#loading {
  position: fixed;
  width: 160px;
  height: 160px;
  line-height: 160px;
  font-size: 30px;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' style='margin:auto' width='200' height='200' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid' display='block'%3E%3Cg transform='matrix(-1 0 0 1 100 0)'%3E%3CanimateTransform attributeName='transform' type='rotate' repeatCount='indefinite' values='360 50 50;240 50 50;120 50 50;0 50 50' keyTimes='0;0.333;0.667;1' dur='0.5319148936170213s' keySplines='0.7 0 0.3 1;0.7 0 0.3 1;0.7 0 0.3 1' calcMode='spline'/%3E%3Cpath fill='%23e15b64' d='M91 74.1C75.6 98 40.7 102.4 21.2 81c11 9.9 26.8 13.5 40.8 8.7 7.4-2.5 13.9-7.2 18.7-13.3 1.8-2.3 3.5-7.6 6.7-8 3.1-.5 5.3 3.1 3.6 5.7z'/%3E%3Cpath fill='%23f8b26a' d='M50.7 5c-4 .2-4.9 5.9-1.1 7.3 1.8.6 4.1.1 5.9.3 2.1.1 4.3.5 6.4.9 5.8 1.4 11.3 4 16 7.8C89.8 31.1 95.2 47 92 62c4.2-13.1 1.6-27.5-6.4-38.7-3.4-4.7-7.8-8.7-12.7-11.7-6.3-3.8-14.7-7-22.2-6.6z'/%3E%3Cpath fill='%23abbd81' d='M30.9 13.4C12 22.7 2.1 44.2 7.6 64.8c.8 3.2 3.8 14.9 9.3 10.5 2.4-2 1.1-4.4-.2-6.6-1.7-3-3.1-6.2-4-9.5-2.1-8.2-1.6-17.3 1.7-25.2 4.7-11.5 14.1-19.7 25.8-23.8-3.2.8-6.3 1.7-9.3 3.2z'/%3E%3C/g%3E%3C/svg%3E") no-repeat center/contain;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
}

#loading p {
  font-size: 16px;
  line-height: 20px;
}

* {
  box-sizing: border-box;
}

#body {
  max-width: 420px;
  min-height: 100vh;
  margin: 0 auto;
  position: relative;
  font-size: 14px;
  padding: 50px 0;
}

.top {
  position: absolute;
  top: 0;
  width: 100%;
  line-height: 40px;
  font-size: 15px;
  background: linear-gradient(-92deg, #823ac6 3%, #cc3571 96%);
}

.logo {
  margin: 0 auto;
  height: 32px;
}

img {
  width: 100%;
}

h3 {
  font-size: 16px;
  font-weight: normal;
  margin: 8px;
}

.btn {
  width: 156px;
  line-height: 36px;
  font-size: 14px;
  border-radius: 8px;
  margin: auto;
  background: linear-gradient(-92deg, #823ac6 3%, #cc3571 96%);
}

.btn i {
  display: inline-block;
  width: 18px;
  height: 18px;
}

.btn * {
  vertical-align: middle;
}

a {
  color: inherit;
  text-decoration: underline;
}

#keys {
  margin: 0;
  padding: 10px 0 0 50px;
  list-style: none;
  text-align: left;
}

#keys li {
  background: linear-gradient(90deg, #ff8859 0%, #ffcc8c 100%);
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 27px;
  font-weight: 700;
  width: 50%;
  float: left;
  padding: 0;
}

#keys::after {
  content: "";
  clear: both;
  display: table;
}

#tags {
  padding: 5px 10px 0 10px;
  text-align: left;
}

#tags span {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 3px;
  margin: 5px;
  background: #d2525e;
}

#items {
  padding: 7px;
}

#items div {
  float: left;
  width: calc(50% - 14px);
  margin: 7px;
  text-align: left;
}

#items div img {
  width: 100%;
  height: 110px;
  object-fit: cover;
}

#items div p {
  margin: 5px 0;
  text-align: justify-all;
}

#items::after {
  content: "";
  display: table;
  clear: both;
}

@keyframes text-color {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }
}

.text-color {
  background-size: 400% 400%;
  background-image: linear-gradient(to left, #ff0000, #ff8000, #fff200, #51ff00, #00d0ff, #9000ff, #ff008c);
  -webkit-background-clip: text;
  animation: text-color 5s ease infinite;
  color: transparent;
}

.fix_foot {
  position: fixed;
  text-align: center;
  background: #242434;
  bottom: 0;
  left: 0;
  right: 0;
  line-height: 50px;
}

a[href*="cnzz"] {
  display: none;
}

.app-loadding {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  right: 0;
  bottom: 0;
  background-color: #0e0e10;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width:375px;

  .img-con {
    width: 100%;
    height: 100%;

    &.start-screen {
      :deep(.van-image) {
        .van-image__img {
          height: auto !important;
        }
      }
    }
  }

  .load-close {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    //top: 20px;
    //right: 20px;
    top: calc(20px + env(safe-area-inset-top));
    right: calc(20px + env(safe-area-inset-right));
    padding: 4px 8px;
    border: 1px solid #fff;
    color: #fff;
    border-radius: 15px;
  }

  &.nantong {
    background-color: #ECECF5;
  }
}

:deep(.van-count-down) {
  font-size: 13px;
  color: #fff;
  margin-right: 2px;
}


.nantong.app-loadding {
  .load-close {
    border: unset;
    height: 30px;
    border-radius: 15px;
    background: #000 !important;
    color: white;
    text-align: center;
    width: 68px;
  }
}
</style>
